import { Link, useLocation } from "react-router-dom";
import clsx from "clsx";

const TABS = [
  { href: "/", label: "top-pulls" },
  { href: "/ev-packs", label: "ev-packs" },
  { href: "/collections", label: "collections" },
  { href: "/singles", label: "singles" },
  { href: "/watchlist", label: "watchlist" },
];

export function TabNav() {
  const { pathname } = useLocation();
  return (
    <nav className="flex border-b border-border bg-panel/40 px-1 md:px-4 font-mono text-[10px] md:text-xs">
      {TABS.map((t) => {
        const active = pathname === t.href;
        return (
          <Link
            key={t.href}
            to={t.href}
            className={clsx(
              "flex-1 md:flex-initial text-center px-1 md:px-3 py-1.5 md:py-2 tracking-wider uppercase border-b-2 -mb-px transition-all duration-150 glitch-hover truncate",
              active
                ? "border-accent text-accent neon-text bg-panel2/50"
                : "border-transparent text-muted hover:text-accent2 hover:border-accent2/40"
            )}
          >
            {/* Caret/cursor decorations only on desktop — mobile needs every
                pixel for the label itself. */}
            {active && <span className="hidden md:inline text-accent2 mr-1">›</span>}
            {t.label}
            {active && (
              <span className="hidden md:inline animate-blink text-accent ml-1">_</span>
            )}
          </Link>
        );
      })}
    </nav>
  );
}
